import { $cmsData, settings } from "../common/setting";
import { cr, interact, URLS } from "fire-wind-water";
import * as $ from "jquery";
import { scmsService } from "../services/site";

class Navs {
  $skelem = ".sk-cms-nav-wap";
  $skelemPc = ".sk-cms-nav";
  isShow = false;
  isActive = false;
  isClass: { [label: string]: boolean } = {};
  isPreview: boolean = settings.isPreview;
  isDesign: boolean = settings.isDesign;
  pid;
  indexPid; // 首页id
  skAfterViewChecked(): void {
    if (this.isPreview) {
      this.pid = URLS.getURL("pid") || (URLS.getURL("des")?null : (window['siteParams']? window['siteParams'].pid:null));
    } else {
      this.pid = settings.pid;
    }
    if (!this.isDesign) {
      this.getMenuList();
    }
    cr.each($cmsData.container, (item: { [label: string]: any }) => {
      const isShowLogin = item.find((i) => i.type === "REGISTRATION");
      cr.each(item, (d) => {
        if (d.type === "NAV") {
          if (d.historyContent.basic?.style.type === "bottomNav") {
            $(this.$skelem).parents().addClass("bottomNav");
            document.body.style["paddingBottom"] =
              "calc(16vw + env(safe-area-inset-bottom))";
          }
          if (d.historyContent.style.navType === "1") {
            $(this.$skelemPc).addClass("fixed");
            if (!isShowLogin) {
              $(this.$skelemPc).addClass("top0");
              document.body.style["paddingTop"] = "0";
            } else {
              document.body.style["paddingTop"] = "146px";
            }
          } else {
            document.body.style["paddingTop"] = "0";
          }
        }
      });
      cr.each(settings.page.items, (d) => {
        if (d.usePages === "index") {
          this.indexPid = d.id;
        }
      });
    });
    console.log($cmsData);
    if (settings.navType == "bottomNav") {
      document.body.style["paddingBottom"] =
        "calc(16vw + env(safe-area-inset-bottom))";
    }
  }
  getMenuList(): void {
    const m = $sk.template.get();
    const param = {
      tenantId: settings.tenantId || URLS.getURL("tid") || (window['siteParams']?window['siteParams'].tid:null),
      siteId: settings.siteId,
      category: interact.isMobile ? 2 : 1,
      sess: m.user.session || null,
      isSave: !settings.isDesign && !URLS.getURL("preview") ? 1 : 0, // 正式访问的链接改成了预览的链接，正式访问时加参数isSave=1
    };
    scmsService.getMenuList(param).subscribe((res) => {
      if (res.result === 0) {
        const menuList = res.content.items;
        cr.each($cmsData.container, (item: { [label: string]: any }) => {
          cr.each(item, (d) => {
            if (d.type === "NAV") {
              if (this.isPreview) {
                cr.each(menuList, (m) => {
                  if (
                    [2, 3, 4, 6, 7].indexOf(parseInt(m.type, 10)) > -1 ||
                    m.linkType == "system"
                  ) {
                    m.link = `${m.href.url}?tid=${settings.tenantId}&sid=${settings.siteId}&cy=${settings.category}&pid=${m.href.pageId}&menuId=${m.id}&t=${settings.t}`;
                  }
                  // 设置栏目页面title、关键词、描述
                  if (m.id === URLS.getURL("menuId") && m.searchTitle) {
                    document.title = m.searchTitle;
                    // 页面keywords/ desc
                    const keyMeta = document.querySelector(
                      "meta[name='keywords']"
                    );
                    if (keyMeta && m.searchKeyword) {
                      keyMeta.setAttribute("content", m.searchKeyword);
                    }
                    const descMeta = document.querySelector(
                      "meta[name='description']"
                    );
                    if (descMeta && m.searchDesc) {
                      descMeta.setAttribute("content", m.searchDesc);
                    }
                  }
                  if (m.subItems) {
                    cr.each(m.subItems, (b) => {
                      if (
                        [2, 3, 4, 6, 7].indexOf(parseInt(b.type, 10)) > -1 ||
                        b.linkType == "system"
                      ) {
                        b.link = `${b.href.url}?tid=${settings.tenantId}&sid=${settings.siteId}&cy=${settings.category}&pid=${b.href.pageId}&menuId=${b.id}&t=${settings.t}`;
                      }
                      if (b.id === URLS.getURL("menuId") && b.searchTitle) {
                        document.title = b.searchTitle;
                        // 页面keywords/ desc
                        const keyMeta = document.querySelector(
                          "meta[name='keywords']"
                        );
                        if (keyMeta && b.searchKeyword) {
                          keyMeta.setAttribute("content", b.searchKeyword);
                        }
                        const descMeta = document.querySelector(
                          "meta[name='description']"
                        );
                        if (descMeta && b.searchDesc) {
                          descMeta.setAttribute("content", b.searchDesc);
                        }
                      }
                    });
                  }
                });
              }
              if (interact.isMobile) {
                if (d.historyContent.basic.style.type === "bottomNav") {
                  this.initWapBottomNavHtml(
                    d.id,
                    menuList,
                    d.historyContent.style
                  );
                } else {
                  this.initWapTopNavHtml(
                    d.id,
                    menuList,
                    d.historyContent.style
                  );
                }
              } else {
                this.initNavHtml(d.id, menuList, d.historyContent.style);
              }
              const _this = this;
              $(".anchor").each(function (index, elem) {
                const componentId = elem.dataset.componentId;
                $(this).on("click", function () {
                  _this.toAnchor(componentId);
                });
              });
              this.skUpdateView();
            }
          });
        });
      }
    });
  }
  // 动态处理PC导航html
  initNavHtml(id, data, style): void {
    let html = "";
    cr.each(data, (r, index) => {
      if (r.isShowTitle && r.isShowTitle != "false" && r.isShowTitle != "0") {
        // 拼接子菜单html
        let subUlHtml = "";
        if (r.subItems && r.subItems.length) {
          subUlHtml = '<ul class="nav-child">';
          cr.each(r.subItems, (sub, index) => {
            if (this.isDesign) {
              subUlHtml += `<li class="nav-item ${
                style.menu2.styleType == "custom" ? style.menu2.fontSize : ""
              }"
                             style="${
                               style.menu2.styleType == "default"
                                 ? ""
                                 : "color:" + style.menu2.color
                             }">
                            <span class="nav-text">${sub.title}</span>
                          </li>`;
            } else if (
              sub.type == 2 ||
              sub.type == 3 ||
              sub.type == 4 ||
              sub.type == 6 ||
              sub.type == 7 ||
              (sub.type == 100 &&
                ((sub.linkType == "custom" && sub.link) ||
                  (sub.linkType == "system" && sub.href.url) ||
                  (sub.linkType == "content" && sub.link)))
            ) {
              subUlHtml += `<li class="nav-item ${
                style.menu2.styleType == "custom" ? style.menu2.fontSize : ""
              }"
                             style="${
                               style.menu2.styleType == "default"
                                 ? ""
                                 : "color:" + style.menu2.color
                             }">
                            <a class="goto-link" href="${sub.link}"  target=${
                sub.linkType == "custom" ? "_blank" : ""
              }>
                              <span class="nav-text">${sub.title}</span>
                            </a>
                          </li>`;
            } else if (sub.linkType == "anchor" && sub.href.pageId) {
              subUlHtml += `<li class="nav-item ${
                style.menu2.styleType == "custom" ? style.menu2.fontSize : ""
              }"
                style="${
                  style.menu2.styleType == "default"
                    ? ""
                    : "color:" + style.menu2.color
                }">
                    <a class="goto-link anchor" data-component-id="${
                      sub.href.componentId
                    }">
                      <span class="nav-text">${sub.title}</span>
                    </a>
               </li>`;
            } else {
              subUlHtml += `<li class="nav-item ${
                style.menu2.styleType == "custom" ? style.menu2.fontSize : ""
              }"
                             style="${
                               style.menu2.styleType == "default"
                                 ? ""
                                 : "color:" + style.menu2.color
                             }">
                            <span class="nav-text">${sub.title}</span>
                          </li>`;
            }
          });
          subUlHtml += "</ul>";
        }
        if (this.isDesign) {
          html += `<li class="nav-item ${
            style.menu1.styleType == "custom" ? style.menu1.fontSize : ""
          }"
                style="${
                  style.menu1.styleType == "default"
                    ? ""
                    : "color:" + style.menu1.color
                }">
                   <span class="nav-text">${r.title}</span>
                  ${subUlHtml}
                </li>`;
        } else if (
          r.type == 2 ||
          r.type == 3 ||
          r.type == 4 ||
          r.type == 6 ||
          r.type == 7 ||
          (r.type == 100 &&
            ((r.linkType == "custom" && r.link) ||
              (r.linkType == "system" && r.href.url) ||
              (r.linkType == "content" && r.link)))
        ) {
          html += `<li class="nav-item ${
            style.menu1.styleType == "custom" ? style.menu1.fontSize : ""
          }"
                style="${
                  style.menu1.styleType == "default"
                    ? ""
                    : "color:" + style.menu1.color
                }">
                    <a class="goto-link" href="${r.link}" target=${
            r.linkType == "custom" ? "_blank" : ""
          }>
                      <span class="nav-text">${r.title}</span>
                    </a>
                    ${subUlHtml}
               </li>`;
        } else if (r.linkType == "anchor" && r.href.pageId) {
          html += `<li class="nav-item ${
            style.menu1.styleType == "custom" ? style.menu1.fontSize : ""
          }"
                style="${
                  style.menu1.styleType == "default"
                    ? ""
                    : "color:" + style.menu1.color
                }">
                    <a class="goto-link anchor" data-component-id="${
                      r.href.componentId
                    }">
                      <span class="nav-text">${r.title}</span>
                    </a>
                    ${subUlHtml}
               </li>`;
        } else {
          html += `<li class="nav-item ${
            style.menu1.styleType == "custom" ? style.menu1.fontSize : ""
          }"
                style="${
                  style.menu1.styleType == "default"
                    ? ""
                    : "color:" + style.menu1.color
                }">
                  <span class="nav-text">${r.title}</span>
                  ${subUlHtml}
                </li>`;
        }
      }
    });
    $(`#NAV_${id} .nav-main .nav-list .nav-ul`).html(html);
  }
  // 动态处理wap顶导航html
  initWapTopNavHtml(id, data, style): void {
    let html = "";
    cr.each(data, (r, index) => {
      if (r.isShowTitle && r.isShowTitle != "false" && r.isShowTitle != "0") {
        // 拼接子菜单html
        let subUlHtml = "";
        if (r.subItems && r.subItems.length) {
          subUlHtml = '<ul class="nd-list-child">';
          cr.each(r.subItems, (sub, index) => {
            if (
              sub.isShowTitle &&
              sub.isShowTitle != "false" &&
              sub.isShowTitle != "0"
            ) {
              if (this.isDesign) {
                subUlHtml += `<li class="nd-item ${
                  style.menu2.styleType == "custom" ? style.menu2.fontSize : ""
                }"
                             style="${
                               style.menu2.styleType == "default"
                                 ? ""
                                 : "color:" + style.menu2.color
                             }">
                             <div class="nd-text">${sub.title}</div>
                          </li>`;
              } else if (
                sub.type == 2 ||
                sub.type == 3 ||
                sub.type == 4 ||
                sub.type == 6 ||
                sub.type == 7 ||
                (sub.type == 100 &&
                  ((sub.linkType == "custom" && sub.link) ||
                    (sub.linkType == "system" && sub.href.url) ||
                    (sub.linkType == "content" && sub.link)))
              ) {
                subUlHtml += `<li class="nd-item ${
                  style.menu2.styleType == "custom" ? style.menu2.fontSize : ""
                }"
                             style="${
                               style.menu2.styleType == "default"
                                 ? ""
                                 : "color:" + style.menu2.color
                             }">
                              <div class="nd-text">
                                <a class="goto-link" href="${
                                  sub.link
                                }"  target=${
                  sub.linkType == "custom" ? "_blank" : ""
                }>
                                    ${sub.title}
                                </a>
                               </div>
                          </li>`;
              } else if (sub.linkType == "anchor" && sub.href.pageId) {
                subUlHtml += `<li class="nd-item ${
                  style.menu2.styleType == "custom" ? style.menu2.fontSize : ""
                }"
                             style="${
                               style.menu2.styleType == "default"
                                 ? ""
                                 : "color:" + style.menu2.color
                             }">
                              <div class="nd-text">
                                <a class="goto-link anchor" data-component-id="${
                                  sub.href.componentId
                                }">
                                    ${sub.title}
                                </a>
                               </div>
                          </li>`;
              } else {
                subUlHtml += `<li class="nd-item ${
                  style.menu2.styleType == "custom" ? style.menu2.fontSize : ""
                }"
                             style="${
                               style.menu2.styleType == "default"
                                 ? ""
                                 : "color:" + style.menu2.color
                             }">
                             <div class="nd-text">${sub.title}</div>
                          </li>`;
              }
            }
          });
          subUlHtml += "</ul>";
        }
        if (this.isDesign) {
          html += `<li class="nd-item ${
            style.menu1.styleType == "custom" ? style.menu1.fontSize : ""
          }"
                      style="${
                        style.menu1.styleType == "default"
                          ? ""
                          : "color:" + style.menu1.color
                      }">
                    <div class="nd-text">${r.title}
                        <div class="item-icon" sk-event.click="active(${index})"
                            style="${
                              style.menu1.styleType == "custom"
                                ? "border-color:" + style.menu1.color
                                : ""
                            };
                                    ${
                                      !r.subItems || !r.subItems.length
                                        ? "display: none"
                                        : ""
                                    }">
                       </div>
                   </div>
                  ${subUlHtml}
                </li>`;
        } else if (
          r.type == 2 ||
          r.type == 3 ||
          r.type == 4 ||
          r.type == 6 ||
          r.type == 7 ||
          (r.type == 100 &&
            ((r.linkType == "custom" && r.link) ||
              (r.linkType == "system" && r.href.url) ||
              (r.linkType == "content" && r.link)))
        ) {
          html += `<li class="nd-item ${
            style.menu1.styleType == "custom" ? style.menu1.fontSize : ""
          }"
                    style="${
                      style.menu1.styleType == "default"
                        ? ""
                        : "color:" + style.menu1.color
                    }">
                    <div class="nd-text">
                       <a class="goto-link" href="${r.link}" target=${
            r.linkType == "custom" ? "_blank" : ""
          }>
                        ${r.title}
                       </a>
                       <div class="item-icon" sk-event.click="active(${index})"
                            style="${
                              style.menu1.styleType == "custom"
                                ? "border-color:" + style.menu1.color
                                : ""
                            };
                                   ${
                                     !r.subItems || !r.subItems.length
                                       ? "display: none"
                                       : ""
                                   }">
                       </div>
                    </div>
                    ${subUlHtml}
               </li>`;
        } else if (r.linkType == "anchor" && r.href.pageId) {
          html += `<li class="nd-item ${
            style.menu1.styleType == "custom" ? style.menu1.fontSize : ""
          }"
                    style="${
                      style.menu1.styleType == "default"
                        ? ""
                        : "color:" + style.menu1.color
                    }">
                    <div class="nd-text">
                       <a class="goto-link anchor" data-component-id="${
                         r.href.componentId
                       }">
                        ${r.title}
                       </a>
                       <div class="item-icon" sk-event.click="active(${index})"
                            style="${
                              style.menu1.styleType == "custom"
                                ? "border-color:" + style.menu1.color
                                : ""
                            };
                                   ${
                                     !r.subItems || !r.subItems.length
                                       ? "display: none"
                                       : ""
                                   }">
                       </div>
                    </div>
                    ${subUlHtml}
               </li>`;
        } else {
          html += `<li class="nd-item ${
            style.menu1.styleType == "custom" ? style.menu1.fontSize : ""
          }"
                        style="${
                          style.menu1.styleType == "default"
                            ? ""
                            : "color:" + style.menu1.color
                        }">
                   <div class="nd-text">${r.title}
                        <div class="item-icon" sk-event.click="active(${index})"
                            style="${
                              style.menu1.styleType == "custom"
                                ? "border-color:" + style.menu1.color
                                : ""
                            };
                                    ${
                                      !r.subItems || !r.subItems.length
                                        ? "display: none"
                                        : ""
                                    }">
                       </div>
                   </div>
                  ${subUlHtml}
                </li>`;
        }
      }
    });
    $(`#NAV_${id} .sk-nav-window .nd-nav .nd-list`).html(html);
  }
  // 动态处理wap底部导航html
  initWapBottomNavHtml(id, data, style): void {
    let html = "";
    cr.each(data, (r, index) => {
      if (
        r.isShowTitle &&
        r.isShowTitle != "false" &&
        r.isShowTitle != "0" &&
        index < 4
      ) {
        if (this.isDesign) {
          html += `<div class="nav-bottom-item ${
            this.pid == (r.href.pageId || "-1") ? "active" : ""
          }"
                      style="${
                        style.menu1.styleType == "default"
                          ? ""
                          : "color:" + style.menu1.color
                      }">
                      <div class="icon">
                        <img class="icon-default" src="${
                          r.icon ? r.icon : "../../assets/images/nav-icon.png"
                        }" cms-smarket alt=""/>
                        <img class="icon-active" src="${
                          r.iconActive
                            ? r.iconActive
                            : "../../assets/images/nav-icon-active.png"
                        }" cms-smarket alt=""/>
                      </div>
                      <div class="title ${
                        style.menu1.styleType == "custom"
                          ? style.menu1.fontSize
                          : ""
                      }"
                      style="${
                        style.menu1.styleType == "custom"
                          ? "color:" + style.menu1.color
                          : ""
                      }">
                        ${r.title}
                      </div>
                    </div>`;
        } else if (
          r.type == 2 ||
          r.type == 3 ||
          r.type == 4 ||
          r.type == 6 ||
          r.type == 7 ||
          (r.type == 100 &&
            ((r.linkType == "custom" && r.link) ||
              (r.linkType == "system" && r.href.url) ||
              (r.linkType == "content" && r.link)))
        ) {
          html += `<div class="nav-bottom-item ${
            this.pid == (r.href.pageId || "-1") ? "active" : ""
          }">
                       <a href="${r.link}" target="_self">
                          <div class="icon" >
                             <img class="icon-default" src="${
                               r.icon
                                 ? r.icon
                                 : "../../assets/images/nav-icon.png"
                             }" cms-smarket alt=""/>
                             <img class="icon-active" src="${
                               r.iconActive
                                 ? r.iconActive
                                 : "../../assets/images/nav-icon-active.png"
                             }" cms-smarket alt=""/>
                          </div>
                          <div class="title ${
                            style.menu1.styleType == "custom"
                              ? style.menu1.fontSize
                              : ""
                          }"
                           style="${
                             style.menu1.styleType == "custom"
                               ? "color:" + style.menu1.color
                               : ""
                           }"
                          > ${r.title}</div>
                       </a>
                   </div>`;
        } else if (r.linkType == "anchor" && r.href.pageId) {
          html += `<div class="nav-bottom-item ${
            this.pid == (r.href.pageId || "-1") ? "active" : ""
          }">
                       <a class="anchor" data-component-id="${
                         r.href.componentId
                       }">
                          <div class="icon" >
                             <img class="icon-default" src="${
                               r.icon
                                 ? r.icon
                                 : "../../assets/images/nav-icon.png"
                             }" cms-smarket alt=""/>
                             <img class="icon-active" src="${
                               r.iconActive
                                 ? r.iconActive
                                 : "../../assets/images/nav-icon-active.png"
                             }" cms-smarket alt=""/>
                          </div>
                          <div class="title ${
                            style.menu1.styleType == "custom"
                              ? style.menu1.fontSize
                              : ""
                          }"
                           style="${
                             style.menu1.styleType == "custom"
                               ? "color:" + style.menu1.color
                               : ""
                           }"
                          > ${r.title}</div>
                       </a>
                   </div>`;
        } else {
          html += `<div class="nav-bottom-item ${
            this.pid == (r.href.pageId || "-1") ? "active" : ""
          }">
                      <div class="icon" >
                         <img class="icon-default" src="${
                           r.icon ? r.icon : "../../assets/images/nav-icon.png"
                         }" cms-smarket alt=""/>
                         <img class="icon-active" src="${
                           r.iconActive
                             ? r.iconActive
                             : "../../assets/images/nav-icon-active.png"
                         }" cms-smarket alt=""/>
                      </div>
                      <div class="title ${
                        style.menu1.styleType == "custom"
                          ? style.menu1.fontSize
                          : ""
                      }"
                       style="${
                         style.menu1.styleType == "custom"
                           ? "color:" + style.menu1.color
                           : ""
                       }"
                      > ${r.title}</div>
                   </div>`;
        }
      }
    });
    $(`#NAV_${id} .bottomNav`).html(html);
  }
  show(): void {
    const b = document.body;
    if (this.isShow) {
      this.isActive = false;
      setTimeout(() => {
        this.isShow = false;
      }, 500);
      b.classList.remove("sk-cms-modal");
    } else {
      this.isActive = true;
      this.isShow = true;
      b.classList.add("sk-cms-modal");
    }
  }

  active(e, i): void {
    if (this.isClass[`active${i}`]) {
      this.isClass[`active${i}`] = false;
    } else {
      this.isClass[`active${i}`] = true;
    }
    const p = e.target.parentNode?.parentNode;
    const c = p.querySelector(".nd-list-child");
    if (c) {
      if (this.isClass[`active${i}`]) {
        p.classList.add("active");
        c.style.height = c.scrollHeight + "px";
      } else {
        p.classList.remove("active");
        c.style.height = 0;
      }
    }
  }
  toAnchor(id): void {
    const elem = document.getElementById(id);
    const isIndex = window.location.href.indexOf("index.html") > -1;
    if (!isIndex) {
      // 非首页的锚点跳转
      const pathArr = window.location.pathname.split("/");
      pathArr.pop();
      const newPathname = pathArr.join("/");
      // 解析URL参数
      const params: URLSearchParams = new URLSearchParams(
        window.location.search
      );
      // 获取特定参数的值
      // 修改参数值
      params.set("pid", this.indexPid);
      // 构建新的URL
      const newUrl =
        window.location.origin +
        newPathname +
        "/index.html?" +
        params.toString() +
        "&anchorId=" +
        id;
      // 替换URL
      window.location.replace(newUrl);
    }
    if (interact.isMobile) {
      this.show();
    } else {
      elem.style.scrollMarginTop = "150px";
    }
    elem.scrollIntoView({ behavior: "smooth" });
  }
  skUpdateView(): void {}
}

export { Navs };
